import React from "react";

const Modal = ({ children }) => {
  return (
    <div className="absolute inset-0">
      <div
        open
        className="fixed inset-0 bg-black/50"
        style={{ "pointer-events": "auto" }}
      >
        <div className="grid-cols-[10px_1fr_10px] grid h-full w-full grid-rows-[minmax(10px,_1fr)_auto_minmax(10px,_1fr)] md:grid-rows-[minmax(20px,_1fr)_auto_minmax(20px,_1fr)] overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
